/** @jsx jsx */
import { React } from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../../styles/Grid';
import { get } from 'lodash';
import DotComponent from '../../../ui/DotComponent';
import * as Styles from './index.style';
import Spacer from '../../../ui/Spacer';
import { SafePureComponent } from '../../../../utils/SafePureComponent';

import PhoneInputForm from './PhoneInputForm';
import BookMeetingForm from './BookMeetingForm';
import DownloadApp from './DownloadApp';

const ActionTypeArr = {
  CTA: 'SingleCTA',
  TALK_TO_US: 'TalkToUs',
  DOWNLOAD_APP: 'DownloadApp',
  BOOK_MEETING: 'BookAMeetingRoom',
};

class ActionBlock extends SafePureComponent {
  renderBlockByType = actionType => {
    const { isDarkMode, fields } = this.props;

    switch (actionType) {
      case ActionTypeArr.CTA:
        const CTALink = get(
          fields,
          'ChosenCallToAction.fields.CTALink.value.href',
          '',
        );
        const CTAText = get(
          fields,
          'ChosenCallToAction.fields.CTAText.value',
          '',
        );

        if (!CTALink) {
          return null;
        }

        return (
          <div css={[Styles.commonCssbutton]}>
            <a href={CTALink} className="CTA-button">
              {CTAText}
            </a>
          </div>
        );
        break;
      case ActionTypeArr.DOWNLOAD_APP:
        return (
          <DownloadApp
            isDarkMode={isDarkMode}
            fields={fields.ChosenCallToAction}
          />
        );
        break;

      case ActionTypeArr.TALK_TO_US:
        return (
          <PhoneInputForm
            isDarkMode={isDarkMode}
            fields={fields.ChosenCallToAction}
          />
        );
        return;

      case ActionTypeArr.BOOK_MEETING:
        const PhoneNumberOptions = get(
          fields,
          'ChosenCallToAction.PhoneNumberOptions',
          [],
        );
        const DomainCountryISOCode2 = get(
          fields,
          'ChosenCallToAction.DomainCountryISOCode2.value',
          '',
        );
        return (
          <BookMeetingForm
            isDarkMode={isDarkMode}
            fields={fields.ChosenCallToAction.fields}
            PhoneNumberOptions={PhoneNumberOptions}
            DomainCountryISOCode2={DomainCountryISOCode2}
          />
        );
        return;

      default:
        return null;
        break;
    }
  };

  render() {
    const { isDarkMode, fields } = this.props;
    const CTA = get(fields, 'ChosenCallToAction', '');
    const actionType = CTA.fields.TypeName.value;
    return (
      <div
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        {this.renderBlockByType(actionType)}
      </div>
    );
  }
}

ActionBlock.displayName = 'FeatureHeros/ActionBlock';

export default ActionBlock;
